<script>
import LoadingComponent from "@/components/LoadingComponent.vue";
import DateFilterComponent from "@/components/LayananTransaksi/DateFilterComponent.vue";
import ReportSummaryComponent from "@/components/LayananTransaksi/LHRTertimbang/ReportSummaryComponent.vue";
import RevenueGraphComponent from "@/components/LayananTransaksi/LHRTertimbang/RevenueGraphComponent.vue";
import RevenueGraphDistributionComponent from "@/components/LayananTransaksi/LHRTertimbang/RevenueGraphDistributionComponent.vue";
import TableStyleComponentDetail from "@/components/LayananTransaksi/LHRTertimbang/TableStyleComponentDetail.vue";
import WarningUploadCTP from "@/components/LayananTransaksi/Alert/WarningUploadCTP.vue";

export default {
  components: {
    WarningUploadCTP,
    LoadingComponent,
    DateFilterComponent,
    ReportSummaryComponent,
    RevenueGraphComponent,
    RevenueGraphDistributionComponent,
    TableStyleComponentDetail,
  },
  data() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);
    return {
      loading: false,
      start_date: firstDayOfMonth.toISOString().split("T")[0],
      end_date: today.toISOString().split("T")[0],
      formatted_date_range: "",
      selectedPeriod: "daily",
      selectedPeriodDistribution: "daily",
      selectedGolongan: ["1", "2", "3", "4", "5"],
      reportData: {
        summaryData: {},
        chartData: [],
        chartDistributionData: [],
        detailData: {},
      },
      fetchDebounceTimeout: null,
    };
  },
  computed: {
    formattedGolongan() {
      return this.selectedGolongan.join(",");
    },
    fetchParamsSummary() {
      return {
        from: this.start_date,
        to: this.end_date,
      };
    },
    fetchParamsChart() {
      return {
        from: this.start_date,
        to: this.end_date,
        // group_ids: "",
      };
    },
    fetchParamsChartDistribution() {
      return {
        from: this.start_date,
        to: this.end_date,
        // group_ids: "",
      };
    },
    fetchParamsDetail() {
      return {
        from: this.start_date,
        to: this.end_date,
        // group_ids: "",
      };
    },
  },
  watch: {
    start_date() {
      this.fetchAllData();
    },
    end_date() {
      this.fetchAllData();
    },
    selectedPeriod() {
      this.fetchDataChart();
    },
    selectedPeriodDistribution() {
      this.fetchDataChartDistribution();
    },
  },
  methods: {
    updateStartDate(newDate) {
      if (this.start_date !== newDate) {
        this.start_date = newDate;
      }
    },
    updateEndDate(newDate) {
      if (this.end_date !== newDate) {
        this.end_date = newDate;
      }
    },
    updateFormattedDateRange(newRange) {
      this.formatted_date_range = newRange;
    },
    updatePeriod(newPeriod) {
      if (this.selectedPeriod !== newPeriod) {
        this.selectedPeriod = newPeriod;
      }
    },
    updatePeriodDistribution(newPeriod) {
      if (this.selectedPeriodDistribution !== newPeriod) {
        this.selectedPeriodDistribution = newPeriod;
      }
    },
    updateGolongan(newGate) {
      if (JSON.stringify(this.selectedGolongan) !== JSON.stringify(newGate)) {
        this.selectedGolongan = newGate;
      }
    },
    async fetchDataSummary() {
      try {
        const response = await this.$axios.get("lhr-weighed-summaries", {
          params: this.fetchParamsSummary,
        });
        this.reportData.summaryData = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataChart() {
      try {
        const response = await this.$axios.get("lhr-weighed-charts", {
          params: this.fetchParamsChart,
        });
        this.reportData.chartData = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataChartDistribution() {
      try {
        const response = await this.$axios.get("lhr-weighed-charts-converted", {
          params: this.fetchParamsChartDistribution,
        });
        this.reportData.chartDistributionData = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataDetail() {
      try {
        const response = await this.$axios.get("lhr-weighed-details", {
          params: this.fetchParamsDetail,
        });
        this.reportData.detailData = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchAllData() {
      this.loading = true;
      await this.fetchDataSummary();
      await this.fetchDataChart();
      await this.fetchDataChartDistribution();
      await this.fetchDataDetail();
      this.loading = false;
    },
  },
  mounted() {
    this.fetchAllData();
  },
};
</script>

<template>
  <div class="pa-0 ma-0">
    <!-- Loading state -->
    <v-row v-if="loading" justify="center" align="center" style="height: 100vh">
      <LoadingComponent />
    </v-row>

    <!-- Content -->
    <div :class="loading ? 'none' : ''">
      <div class="pb-3 pt-4 px-10">
        <v-row no-gutters>
          <v-col
            align="left"
            class="my-auto pe-5"
            cols="12"
            xs="12"
            sm="12"
            md="7"
          >
            <WarningUploadCTP
              :start_date="this.start_date"
              :end_date="this.end_date"
            />
          </v-col>
          <v-col align="right" class="my-auto" cols="12" xs="12" sm="12" md="5">
            <v-sheet>
              <v-row no-gutters>
                <v-col align="left" class="my-auto" cols="2">
                  <v-sheet>
                    <span
                      class="text--black text-uppercase"
                      style="font-size: 12px; font-weight: 400; color: #bbbbbb"
                      >Filter</span
                    >
                    <h6
                      class="text--black"
                      style="font-size: 14px; font-weight: 400"
                    >
                      Pilih Tanggal
                    </h6>
                  </v-sheet>
                </v-col>
                <v-col align="right" class="my-auto" cols="10">
                  <v-sheet>
                    <DateFilterComponent
                      @update:startDate="updateStartDate"
                      @update:endDate="updateEndDate"
                      @update:formattedDateRange="updateFormattedDateRange"
                    />
                  </v-sheet>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
      <ReportSummaryComponent
        v-if="reportData && reportData?.summaryData"
        :data="reportData?.summaryData"
        :selected-date="start_date"
      />
      <RevenueGraphComponent
        :data="reportData.chartData"
        @update:selectedPeriod="updatePeriod"
      />
      <RevenueGraphDistributionComponent
        :data="reportData.chartDistributionData"
        @update:selectedPeriod="updatePeriodDistribution"
        @update:selectedGolongan="updateGolongan"
      />
      <!-- Detail Section -->
      <div class="pb-3 pt-4 px-10">
        <div class="mb-5 rounded-xl py-4 px-6 text-center bordered">
          <h3 style="font-size: 18px; font-weight: 500" class="text-uppercase">
            Detail
          </h3>
        </div>
        <div class="py-5">
          <v-row class="mb-4">
            <v-col cols="9" class="my-auto">
              <h3 class="text--black" style="font-size: 20px; font-weight: 500">
                {{ formatted_date_range }}
              </h3>
            </v-col>
          </v-row>
          <TableStyleComponentDetail :data="reportData.detailData" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bordered {
  background-color: #dae7ff;
  border-left: 4px solid #497bdd;
  border-right: 4px solid #497bdd;
}
</style>
